/**
 * Legacy localStorage menu cache — retired when the sidebar became a
 * synchronous computation over the static catalog. Purge leftovers once so
 * old (potentially multi-MB) entries don't linger in users' browsers.
 *
 * Lives in its own module so `AuthContext` (mounted in EVERY portal, incl.
 * /growth, /agency, /vendor) can clear it on sign-out without importing
 * `MenuContext`, which drags the hotel menu / selection / capability graph —
 * and its GraphQL documents — into every portal (role-document-coverage,
 * #2633, attributed six hotel documents to every growth page through it).
 */
const LEGACY_CACHE_KEY_PREFIX = 'taskyinn-menu-cache'

/** Remove every legacy menu-cache entry from localStorage (no-op on the server). */
export function clearMenuCache(): void {
  if (typeof window === 'undefined') return
  try {
    Object.keys(localStorage)
      .filter(k => k.startsWith(LEGACY_CACHE_KEY_PREFIX))
      .forEach(k => localStorage.removeItem(k))
  } catch {
    // Ignore errors
  }
}
